

































import {
  Component,
  Vue
} from "vue-property-decorator";
import { paneData } from '@/static/paneData';
import Pane from '@/components/Pane/Pane.vue';

@Component({
  components: {
    Pane,
  },
})
export default class Home extends Vue {
    public paneData = paneData
}
